import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useCallback } from 'react';
import { P as Popper } from '../Popper/Popper-e71d903b.js';
import { M as MenuList } from './MenuList/MenuList-fb006add.js';
import { i as isEventFromWithinElement } from '../LocalModules/storm-ui-utils/dist/esm/isEventFromWithinElement-7e2fe92b-611e9565.js';
import { k as keys } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-04a50e15-b033061a.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-189dc982.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-12ae0974.js';
import { c as composeRefs } from '../LocalModules/storm-ui-utils/dist/esm/composeRefs-cac293ab-4034111b.js';
import { O as OnRootContainerMousedown$1 } from '../LocalModules/storm-ui-utils/dist/esm/OnRootContainerMousedown-1beb3944-db9938a5.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-ea7cc233-62dc80e0.js';

const Menu = ({
  id,
  align = 'start',
  children,
  disabled = false,
  onClose,
  onClick,
  isOpen,
  position = 'bottom',
  trigger,
  withArrow = false,
  taktId,
  ...rest
}) => {
  const popperRef = useRef(null);
  const triggerRef = useRef(null);
  const onClickOutside = useCallback(event => {
    if (popperRef.current && !isEventFromWithinElement(event, popperRef.current) && !isEventFromWithinElement(event, triggerRef.current)) {
      onClose === null || onClose === void 0 || onClose(event);
    }
  }, [onClose]);
  const onClickTrigger = useCallback(event => {
    if (!disabled) {
      event.stopPropagation();
      event.preventDefault();
      onClick === null || onClick === void 0 || onClick(event);
    }
  }, [disabled, onClick]);
  const onKeyDown = useCallback(event => {
    const {
      key
    } = event;
    switch (key) {
      case keys.ESCAPE:
      case keys.TAB:
      case keys.ENTER:
      case keys.SPACE:
        onClose === null || onClose === void 0 || onClose(event);
        event.preventDefault();
        break;
    }
  }, [onClose]);
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    fallbackId: createStormTaktId('menu')
  }, /*#__PURE__*/React__default.createElement(Popper, _extends({
    align: align,
    autoFocus: true,
    position: position,
    isOpen: isOpen,
    popperRef: popperRef,
    padding: "none",
    spacing: 10,
    withArrow: withArrow
  }, rest, {
    onClick: onClickTrigger,
    onKeyDown: onKeyDown,
    trigger: /*#__PURE__*/React__default.cloneElement(trigger, {
      ...trigger.props,
      'aria-haspopup': 'menu',
      'aria-controls': `${id}`,
      'aria-expanded': isOpen,
      id: `${id}-trigger`,
      ref: trigger.props.buttonRef ? composeRefs(triggerRef, trigger.props.buttonRef) : triggerRef,
      disabled
    })
  }), /*#__PURE__*/React__default.createElement(OnRootContainerMousedown$1, {
    rootContainer: typeof document !== 'undefined' ? document.documentElement : undefined,
    handler: onClickOutside
  }, /*#__PURE__*/React__default.createElement(MenuList, {
    id: `${id}`,
    "aria-labelledby": `${id}-trigger`
  }, children))));
};
Menu.defaultProps = {
  disabled: false,
  onClose: noop
};
var Menu$1 = Menu;

export { Menu$1 as M };
//# sourceMappingURL=Menu-bd9ec21d.js.map
